import { asyncActionCreator } from 'src/utils/loadingUtils';
import { getBureauReports, getBuroReportDetails } from 'src/services/bureauReportService';
import { SnackBarVariants } from 'src/utils/constants/common';
import { showMessage } from './snackBarActions';

export const LOAD_BUREAU_REPORT_DETAIL = asyncActionCreator('LOAD_BUREAU_REPORT_DETAIL');
export const LOAD_BUREAU_REPORTS = asyncActionCreator('LOAD_BUREAU_REPORTS');
export const SAVE_BUREAU_REPORT_OPTIONS = 'SAVE_BUREAU_REPORT_OPTIONS';
export const CLEAR_BUREAU_REPORT_OPTIONS = 'CLEAR_BUREAU_REPORT_OPTIONS';
export const CLEAR_BUREAU_REPORTS = 'CLEAR_BUREAU_REPORTS';
export const SAVE_BUREAU_REPORT_DETAIL_OPTIONS = 'SAVE_BUREAU_REPORT_DETAIL_OPTIONS';
export const CLEAR_BUREAU_REPORT_DETAIL = 'CLEAR_BUREAU_REPORT_DETAIL';
export const loadBureauReportDetail = ({ reportId, page, limit, clearSearchParams, ...searchParams }) => async dispatch => {
  try {
    dispatch({ type: LOAD_BUREAU_REPORT_DETAIL.start });

    const reqOptions = {
      reportId,
      limit
    };

    if (page > 0) {
      reqOptions.offset = page * limit;
    }

    if (searchParams.clientName) {
      reqOptions.clientName = searchParams.clientName;
    }
    if (searchParams.paymentStatus) {
      reqOptions.paymentStatus = searchParams.paymentStatus;
    }

    const response = await getBuroReportDetails(reqOptions);

    dispatch({
      type: LOAD_BUREAU_REPORT_DETAIL.success,
      items: response.rows || response.items || [],
      count: response.count || 0,
      reportInfo: response.reportType ? { type: response.reportType } : null,
      page,
      searchParams: clearSearchParams ? {} : searchParams
    });
  } catch (error) {
    dispatch(
      showMessage({
        message: error.message,
        variant: SnackBarVariants.ERROR
      })
    );
    dispatch({ type: LOAD_BUREAU_REPORT_DETAIL.failure });
  }
};

export const loadBureauReports = options => async dispatch => {
  try {
    const page = options?.page || 0;
    const limit = options?.limit || +process.env.REACT_APP_TABLE_SIZE;
    const reportType = options?.reportType;

    dispatch({ type: LOAD_BUREAU_REPORTS.start });
    dispatch({
      type: SAVE_BUREAU_REPORT_OPTIONS,
      options: { page, limit, reportType }
    });

    const bureauReports = await getBureauReports({
      page,
      limit,
      type: reportType
    });

    return dispatch({
      type: LOAD_BUREAU_REPORTS.success,
      items: bureauReports.rows || bureauReports.items || [],
      count: bureauReports.count || 0
    });
  } catch (error) {
    dispatch(
      showMessage({ message: error.message, variant: SnackBarVariants.ERROR })
    );
    return dispatch({ type: LOAD_BUREAU_REPORTS.failure });
  }
};
